const TextfieldSimple = (props) => {

    const inputId = `input-${props.label.replace(/\s+/g, '-').toLowerCase()}`;
    
    const handeValueChange = (e) => {

        let newText = e.target.value;
        newText = stripHtmlTags(newText);
        
        props.OnChangeValue(newText);
    }

    const stripHtmlTags = (text) => {
        const div = document.createElement("div");
        div.innerHTML = text;
        let plainText = div.textContent || div.innerText || "";
        // Remove newline characters
        plainText = plainText.replace(/\n/g, ' ');
        return plainText;
    };
    
    return(
        <div>
            <div>
                <label htmlFor={inputId} className={'p-1'}>
                    {props.label}
                </label>
            </div>
            <div className={'p-1 rounded-md'}>
                <input
                    id={inputId}
                    onChange={handeValueChange}
                    type={'text'} 
                    defaultValue={props.value}>
                </input>
            </div>
        </div>
    );
}

export default TextfieldSimple;